import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    spacer: 'h-(--tapbar-height) shrink-0 md:hidden',
    base: 'fixed inset-x-0 bottom-0 z-60 flex w-full translate-y-(--tapbar-shift,0px) flex-col bg-white pb-[env(safe-area-inset-bottom)] shadow-[0px_0px_12px_rgba(0,0,0,0.07)] md:hidden',
    container: 'flex h-(--tapbar-content-height) shrink-0 justify-between',
    item: 'flex-center w-1/5 flex-col flex-wrap select-auto',
    logo: 'h-8 w-auto',
    companyName: '',
    button: 'flex-center relative size-8 p-0',
    linkIconWrapper: 'flex-center relative flex size-8',
    linkIcon: 'link size-8',
    linkCounter: 'bg-color-accent absolute top-0 left-4.5'
  },
  variants: {
    withoutShadow: {
      true: {
        base: 'shadow-none'
      }
    }
  },
  defaultVariants: {}
});
